import { cn } from "@/lib/utils";

/** The mark's rings, outermost first, in its 32-unit frame. */
export const TWIN_MARK_RINGS = [
  { r: 13.2, fill: "#D91B5C" },
  { r: 11.2, fill: "#E8501C" },
  { r: 9.2, fill: "#D49A00" },
  { r: 7.2, fill: "#00A56A" },
  { r: 5.2, fill: "#008FB8" },
  { r: 3.2, fill: "#7456E8" },
] as const;

/** Scales the outer ring to the edge of the 32-unit frame for avatar crops,
 *  where the disc IS the avatar and a breathing margin reads as a plate. */
const BLEED = 16 / 13.2;

export function TwinMark({
  className,
  bleed = false,
}: {
  className?: string;
  /** Fill the frame edge-to-edge. Use inside circular avatars; leave off for
   *  inline glyphs next to text, where the margin is wanted. */
  bleed?: boolean;
}) {
  return (
    <svg
      aria-hidden
      className={cn("shrink-0", className)}
      focusable="false"
      viewBox="0 0 32 32"
    >
      {TWIN_MARK_RINGS.map((ring) => (
        <circle
          key={ring.fill}
          cx="16"
          cy="16"
          fill={ring.fill}
          r={bleed ? ring.r * BLEED : ring.r}
        />
      ))}
    </svg>
  );
}
